import React, { useState, useEffect } from "react";
import Layout from "../Layout/Layout";
import "../css/courses-view.css";
import "../css/courses-module.css";

import { API_BASE } from "../Utils/constant";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { AUTH_TOKEN } from "../constants/localStorageKeys";
import { retrieve, save } from "../helpers/StorageHelper";

export default function ModuleView() {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [modules, setModules] = useState([]);
  const [courseTitle, setCourseTitle] = useState("");
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { currentModuleId, goToNext } = location.state || {};

  useEffect(() => {
    const token = retrieve(AUTH_TOKEN);
    save("courseId", courseId);

    const fetchModules = async () => {
      try {
        const res = await axios.get(`${API_BASE}/user/modules`, {
          params: { course_id: courseId },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = res.data?.data;
        setCourseTitle(data.course.title);
        setModules(data.modules);
        setProgress(data.course.completion_percentage || 0);
      } catch (error) {
        console.error("Error fetching course modules", error);
      } finally {
        setLoading(false);
      }
    };

    fetchModules();
  }, [courseId]);

  useEffect(() => {
    if (modules.length > 0 && currentModuleId && goToNext) {
      const currentIndex = modules.findIndex(
        (m) => m.id === parseInt(currentModuleId, 10),
      );
      const nextModule = modules[currentIndex + 1];
      if (nextModule) {
        handleModuleClick(nextModule.id);
      }
    }
  }, [modules, currentModuleId, goToNext]);

  const handleModuleClick = async (moduleId) => {
    const token = retrieve(AUTH_TOKEN);

    try {
      const res = await axios.get(
        `${API_BASE}/user/modules/${moduleId}/chapters`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const module1 = res.data?.data.module;
      const firstChapterId = module1.chapters?.[0]?.id;

      await axios.post(
        `${API_BASE}/user/module-chapter/update-status`,
        {
          module_id: moduleId,
          chapter_id: firstChapterId,
          status: "in_progress",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      navigate(`/modules/${moduleId}/chapters`);
    } catch (error) {
      console.error("Error updating module chapter status:", error);
    }
  };

  return (
    <Layout>
      <div className="page-content">
        <div className="setting-content">
          <div className="d-flex align-items-center mb-3 mb-md-4">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-link p-0 me-2"
              style={{ color: "#e6ecf1", textDecoration: "none" }}
            >
              <img src="/icons/arrow-left.svg" alt="Back" />
            </button>
            <h1 className="text-heading-h2 m-0" style={{ color: "#e6ecf1" }}>
              {courseTitle}
            </h1>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            </div>
          ) : (
            <div className="course-view-container">
              <div
                className="courses-modules-container"
                style={{ maxWidth: "300px", flex: "2" }}
              >
                <h1
                  className="text-heading-h3 mb-0"
                  style={{ color: "var(--Text-100, #d0d8df)" }}
                >
                  Modules
                </h1>
                <ul className="nav nav-tabs courses-view-custom-tabs">
                  <ul className="nav nav-tabs courses-view-custom-tabs">
                    {modules.map((module, index) => (
                      <li className="nav-item" key={`nav-${module.id}`}>
                        <a
                          href="#"
                          className={`nav-link text-body-b3 module-hover-effect`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleModuleClick(module.id);
                          }}
                        >
                          <div
                            className={`module-status ${
                              module.status === "completed"
                                ? "completed-video"
                                : ""
                            }`}
                          >
                            {module.status === "completed" && (
                              <img
                                alt="image-alt"
                                src="/icons/check-small.svg"
                              />
                            )}
                          </div>
                          <span
                            className="text-body-b3"
                            style={{ color: "var(--Text-200, #c8ced3)" }}
                          >
                            Module {index + 1} - {module.title}
                            {/* <span className="courses-link-chapter-detail"> */}
                            {/* </span> */}
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
